import { Stack, Typography, Divider, MenuItem } from '@mui/material';
import { useWatch } from 'react-hook-form';

import { RHFSelect, RHFTextField, RHFFilePickerField } from '@app/components';
import { Strings, memberSources } from '@app/constants';
import { StyledInputs } from '../styles';
// --------------------------------------------
interface Props {
  filePickerName?: string;
}
const AddCandidateForm = ({ filePickerName }: Props) => {
  const [source] = useWatch({ name: ['source'] });

  return (
    <Stack pt={3}>
      {/* Heading */}
      <Stack spacing={1}>
        <Typography variant="body1">{Strings.addCandidate.enterTheCandidateInfo}</Typography>
      </Stack>
      <Divider sx={{ my: 3 }} />

      {/* Form */}
      <StyledInputs>
        <Stack rowGap={2} gap={2} direction="row" flexWrap="wrap">
          <RHFTextField required name="firstName" type="text" label={Strings.field.firstName} />
          <RHFTextField required name="lastName" type="text" label={Strings.field.lastName} />
          <RHFTextField required name="personalEmail" label={Strings.field.personalEmail} />
          <RHFTextField name="phone" type="number" label={Strings.field.phone} />
          <RHFSelect required name="source" type="select" label={Strings.field.source}>
            {memberSources.map((option) => (
              <MenuItem key={option.value} value={option.label}>
                {option.label}
              </MenuItem>
            ))}
          </RHFSelect>
          {source === 'Reference' && (
            <RHFTextField name="referenceBy" required label={Strings.field.enterReferenceName} />
          )}
          {source === 'Other' && (
            <RHFTextField name="other" required label={Strings.field.enterOtherSourceName} />
          )}
          <RHFTextField
            name="applyingFor"
            required
            label={Strings.field.applyingFor}
            helperText={Strings.addCandidate.pleaseEnterThePositionTheCandidate}
          />
          <RHFFilePickerField
            name="resume"
            label={Strings.field.resume}
            required
            filePickerName={filePickerName}
          />
        </Stack>
      </StyledInputs>
    </Stack>
  );
};

export { AddCandidateForm };
